import React from 'react'
import { Menu as UikitMenu } from './MenuKit'

const Menu = (props) => {
  return <UikitMenu {...props} />
}

export default Menu
